/**
 * Events - Archive (listing view)
 */

'use strict';

var ui = require('../misc/layout');
var searchUtil = require('../misc/search');

// Constructor
var FrontEventsArchive = function () {
    if ($('main#content').find('.events .event').length > 0) {
        this.uiInitEvents();
    }

    if (!$('body').hasClass('post-type-archive-cm-events')) {
        return;
    }

    $(document).ready((function () {
        if (bowser.mobile) {
            $('#site-header').addClass('force-no-sticky');
            this.$searchForm = $('#events-search-mobile');
            this.searchFormName = 'events-search-mobile';
        } else {
            this.$searchForm = $('#events-search');
            this.searchFormName = 'events-search';
        }

        this.uiInitMaterialize();
        this.uiOpenDatePickerOrModal();
        this.updateWhereSelects();
        this.multipleSelectAllOption();
        this.uiInputSearchBy();

        if ($(window).width() > 500) {
            $('.search-form select:not(.browser-default)').formSelect();
            $('.advanced-search-form select:not(.browser-default)').formSelect();

            this.uiSlideDownAdvancedSearch();
        }

        this.searchForm();
        this.infiniteScroll();
        this.reinitializeSearch();
    }).bind(this));
};

FrontEventsArchive.prototype = {
    lockAjaxGetResults: false,
    colorHover: '#FFFFFF',
    monthsFull: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    weekdaysFull: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    weekdaysShort: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    weekdaysLetter: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],

    uiInitEvents: function () {
        // Equal height for each item of the grid (per lines)
        $('.events .row > .event').matchHeight();

        var events = $('.events .row > .event');
        this.setItemHoverAnimation(events);
    },

    setItemHoverAnimation: function (events) {
        var self = this;

        events.each(function () {
            self.setColors(this, self.colorHover);
        });

        // Hover
        events.hover(function () {
            $(this).addClass('hover');
            self.setColorsHover(this, self.colorHover);

            var totalHeight = $('.inner', this).height();
            var contentHeight = $('.content-inner', this).outerHeight(true);
            var badgeCategoryTop = (totalHeight - contentHeight) - 10;

            $('.category', this).css('top', badgeCategoryTop + 'px');
        }, function () {
            $(this).removeClass('hover');
            self.setColors(this, self.colorHover);

            $('.category', this).css('top', '');
        });
    },

    setColors: function (event, colorHover) {
        var color = $(event).data('category-color');

        if (color.length == 7) {
            $('.inner', event).css('background-color', color);
            $('.inner .content', event).css('background-color', color);
            $('.inner .category', event).css('color', color);
            $('.inner .category', event).css('background-color', colorHover);
            $('.inner .content .title', event).css('color', colorHover);
        }
    },

    setColorsHover: function (event, colorHover) {
        var color = $(event).data('category-color');

        $('.inner', event).css('background-color', colorHover);
        $('.inner .content', event).css('background-color', colorHover);
        $('.inner .category', event).css('color', colorHover);
        $('.inner .category', event).css('background-color', color);
        $('.inner .content .title', event).css('color', color);
    },

    createIntervalDatepicker: function (selector, currentYear, endYear, pickaDateContainer, minDate) {
        if (minDate === null) {
            minDate = new Date()
        }
        var self = this;
        $(selector).datepicker({
            container: pickaDateContainer,
            format: 'dd.mm.yyyy',
            minDate: minDate,
            defaultDate: new Date(),
            firstDay: 1,
            showClearBtn: true,
            yearRange: [currentYear, endYear],
            i18n: {
                cancel: null,
                clear: comedien.i18n.pickadateClear,
                done: comedien.i18n.pickadateClose,
                weekdaysShort: this.weekdaysShort,
                weekdaysLetter: this.weekdaysLetter,
                weekdays: this.weekdaysFull,
                months: this.monthsFull
            },
            onSelect: function(date) {
                // console.log(date)
            },
            onDraw: function() {
                // console.log(this)
            },
            onOpen: function() {
                var startDate = $('#'+ self.searchFormName +' #whenIntervalStart').val();
                if (this.$el[0].id === 'date-end' && startDate === '') {
                    this.close();
                } else {
                    $('#intervalModal').modal('close');
                }
            },
            onClose: function () {
                // Get the value
                var value = this.date;
                var day = value.getDate();
                var monthIndex = value.getMonth()+1;
                var year = value.getFullYear();

                if (monthIndex < 10) {
                    monthIndex = '0'+monthIndex;
                }
                if (value !== '') {
                    var datetime = year + '-' + monthIndex + '-' + day;
                    if (this.$el[0].id === 'date-start') {
                        $('#'+ self.searchFormName +' #whenIntervalStart').val(datetime);
                        $('#date-end').datepicker('destroy');
                        self.createIntervalDatepicker('#date-end', currentYear, endYear, pickaDateContainer, this.date)
                    } else if (this.$el[0].id === 'date-end') {
                        $('#'+ self.searchFormName +' #whenIntervalEnd').val(datetime);
                    }
                }
                $('#intervalModal').modal('open');
                $('.interval').blur();
                $(document.activeElement).blur();
            },
        });
    },

    createHistoryDatepicker: function (selector, currentYear, startYear, pickaDateContainer, minDate) {
        var self = this;
        $(selector).datepicker({
            container: pickaDateContainer,
            format: 'dd.mm.yyyy',
            minDate: minDate,
            maxDate: new Date(),
            defaultDate: new Date(),
            firstDay: 1,
            showClearBtn: true,
            yearRange: [startYear, currentYear],
            i18n: {
                cancel: null,
                clear: comedien.i18n.pickadateClear,
                done: comedien.i18n.pickadateClose,
                weekdaysShort: this.weekdaysShort,
                weekdaysLetter: this.weekdaysLetter,
                weekdays: this.weekdaysFull,
                months: this.monthsFull
            },
            onSelect: function(date) {
                // console.log(date)
            },
            onDraw: function() {
                // console.log(this)
            },
            onOpen: function() {
                $('#historyModal').modal('close');
            },
            onClose: function () {
                // Get the value
                var value = this.date;
                var day = value.getDate();
                var monthIndex = value.getMonth()+1;
                var year = value.getFullYear();

                if (monthIndex < 10) {
                    monthIndex = '0'+monthIndex;
                }
                if (value !== '') {
                    var datetime = year + '-' + monthIndex + '-' + day;
                    if (this.$el[0].id === 'history-date-start') {
                        $('#'+ self.searchFormName +' #whenArchiveStart').val(datetime);
                        $('#history-date-end').datepicker('destroy');
                        self.createHistoryDatepicker('#history-date-end', currentYear, startYear, pickaDateContainer, this.date)
                    } else if (this.$el[0].id === 'history-date-end') {
                        $('#'+ self.searchFormName +' #whenArchiveEnd').val(datetime);
                    }
                }
                $('#historyModal').modal('open');
                $('.history').blur();
                $(document.activeElement).blur();
            },
        });
    },

    uiInitMaterialize: function () {
        var currentYear = parseInt(new Date().getFullYear(), 10);
        var endYear = parseInt(currentYear+10, 10);
        var startYear = parseInt(currentYear-10, 10);

        var pickaDateContainer = '#site-header';
        if ($(window).width() < 500) {
            pickaDateContainer = 'body';
        }

        this.createIntervalDatepicker('.interval', currentYear, endYear, pickaDateContainer);
        this.createHistoryDatepicker('.history', currentYear, startYear, pickaDateContainer);
    },

    uiOpenDatePickerOrModal: function () {
        $('body').on('change', '.search-form #when', function () {
            var value = $(this).find("option:selected").val();

            switch (value) {
                case "archive":
                    $('#historyModal').modal('open');
                    break;
                case "interval":
                    $('#intervalModal').modal('open');
                    break;
            }
        });
    },

    uiSlideDownAdvancedSearch: function () {
        $('#search-box #more-criteria').on('click', function () {
            var button = $(this);

            $('.advanced-search').toggle(0, function () {
                $('#events .overlay').toggleClass('hidden');

                // Updating title's button
                var newTitle = button.attr("data-title");
                var currentTitle = button.text();
                button.text(newTitle);
                button.attr("data-title", currentTitle);

                // Updating actors'listing 
                $('#events').toggleClass('without-advanced-search');
            });
        });
    },


    uiInputSearchBy: function() {
        var self = this;

        $('body').on('click', '.search-form .input-field-searchquery', function() {
            var searchBy = $('#'+ self.searchFormName +' #searchby').val();

            if (searchBy == '') {
                $('.col-searchby .select-dropdown', self.$searchForm).trigger('click');
            }
        });

        $('body').on('change', '.search-form #searchby', function() {
            if ($(this).val() != '') {
                $('#'+ self.searchFormName +' #searchquery').removeAttr('disabled').val('');

                var label = '';
                switch ($(this).val()) {
                    case 'title': label = comedien.i18n.eventsSearchByTitle; break;
                    case 'casting-author': label = comedien.i18n.eventsSearchByAuthor; break;
                    case 'casting-actor': label = comedien.i18n.eventsSearchByActor; break;
                }

                $('#'+ self.searchFormName +' label[for="searchquery"]').text(label).removeClass('active');
            } else {
                $('#'+ self.searchFormName +' #searchquery').prop('disabled', true);
                $('#'+ self.searchFormName +' label[for="searchquery"]').text(comedien.i18n.eventsSearchBy).removeClass('active');
            }
        });
    },

    ajaxGetResults: function (callbackDone, callbackFail, offset) {
        var self = this;
        var isArchive = false;
        var whenValue = $('#'+ self.searchFormName +' #when').val();

        if (whenValue === 'interval') {
            var start = $('#'+ self.searchFormName +' #whenIntervalStart').val();
            var end = $('#'+ self.searchFormName +' #whenIntervalEnd').val();

            if (start != '' && end != '') {
                whenValue = [start, end];
            }
        } else if (whenValue === 'archive') {
            var start = $('#'+ self.searchFormName +' #whenArchiveStart').val();
            var end = $('#'+ self.searchFormName +' #whenArchiveEnd').val();

            if (start != '' && end != '') {
                whenValue = [start, end];
                isArchive = true;
            }
        }

        if (bowser.mobile) {
            var locationValue = $('#events-search-mobile #location').val();
            var placeValue = $('#events-search-mobile #place').val();
        } else {
            var locationValue = $('#advanced-events-search #location').val();
            var placeValue = $('#advanced-events-search #place').val();
        }

        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'events.get_results',
                security: comedien.security,
                nbDisplayedEvents: offset,
                searchby: $('#'+ self.searchFormName +' #searchby').val(),
                searchquery: $('#'+ self.searchFormName +' #searchquery').val(),
                when: whenValue,
                isArchive: isArchive,
                area: $('#'+ self.searchFormName +' #area').val(),
                category: $('#'+ self.searchFormName +' #category').val(),
                location: locationValue,
                place: placeValue
            }
        }).done(callbackDone).fail(callbackFail);
    },

    updateDisplay: function (events) {
        var self = this;

        // Hide the loading spinner
        $('#events .loading').fadeOut();

        self.setItemHoverAnimation(events);
    },

    searchForm: function () {
        var self = this;

        if (!bowser.mobile) {

            this.$searchForm.add('#advanced-events-search').on('submit', function (e) {
                e.preventDefault();

                // Slide up the search panel
                if ($('.advanced-search').is(':visible')) {
                    $('#search-box #more-criteria').trigger('click');
                }

                if (self.lockAjaxGetResults) {
                    // Pending AJAX request... wair
                    return;
                }

                self.lockAjaxGetResults = true;

                // Display the loading spinner
                $('.event-listing').html('');
                $('#events .loading').fadeIn();

                self.ajaxGetResults(function (response) {
                    if (response.success) {
                        setTimeout(function () {
                            var total = parseInt(response.data.nbTotalEvents);

                            if (isNaN(total)) {
                                total = 0;
                            }

                            var entity = $('.events h1').data("entity");

                            if (total == 0) {
                                $('.events h1').html('<span>' + comedien.i18n.placesTitleCountZero + '</span>' + ' ' + entity);
                            } else if (total == 1) {
                                $('.events h1').html('<span>' + total + '</span>' + ' ' + entity);
                            } else {
                                $('.events h1').html('<span>' + total + '</span>' + ' ' + entity + 's');
                            }

                            if (total == 0) {
                                $('.bottom-reinit').removeClass('hidden');
                            } else {
                                $('.bottom-reinit').addClass('hidden');
                            }

                            // Update the new actors in list
                            $('.event-listing').html(response.data.events);

                            var events = $('.event-listing').find(".event");

                            // Update the display
                            self.updateDisplay(events);
                        }, 1000);
                    } else {
                        console.log('An error occured!');
                    }

                    self.lockAjaxGetResults = false;
                }, function (jqXHR, textStatus) {
                    self.lockAjaxGetResults = false;
                    console.log("Request failed: " + textStatus);
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }, 0);
            });
        } else {

            $('body').on('submit', self.$searchForm, function(e) {
                e.preventDefault();

                if (self.lockAjaxGetResults) {
                    // Pending AJAX request... wair
                    return;
                }

                self.lockAjaxGetResults = true;

                $('#search-box-mobile .btn-submit').addClass('disabled');
                $('#search-box-mobile .close-search').trigger('click');

                // Display the loading spinner
                $('.event-listing').html('');
                $('#events .loading').fadeIn();

                self.ajaxGetResults(function (response) {
                    if (response.success) {
                        setTimeout(function () {
                            $('#search-box-mobile .btn-submit').removeClass('disabled');

                            var total = parseInt(response.data.nbTotalEvents);

                            if (isNaN(total)) {
                                total = 0;
                            }

                            var entity = $('.events h1').data("entity");

                            if (total == 0) {
                                $('.events h1').html('<span>' + comedien.i18n.placesTitleCountZero + '</span>' + ' ' + entity);
                            } else if (total == 1) {
                                $('.events h1').html('<span>' + total + '</span>' + ' ' + entity);
                            } else {
                                $('.events h1').html('<span>' + total + '</span>' + ' ' + entity + 's');
                            }

                            // Update the new actors in list
                            $('.event-listing').html(response.data.events);

                            var events = $('.event-listing').find(".event");

                            // Update the display
                            self.updateDisplay(events);
                        }, 1000);
                    } else {
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }

                    self.lockAjaxGetResults = false;
                }, function (jqXHR, textStatus) {
                    self.lockAjaxGetResults = false;
                    console.log("Request failed: " + textStatus);
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);

                    $('#search-box-mobile .btn-submit').removeClass('disabled');
                    $('#search-box-mobile .close-search').trigger('click');
                }, 0);
            });
        }
    },

    updateWhereSelects: function () {
        // Areas (Où)
        $('body').on('change', '#area', function () {
            //var value = $(this).find(':selected:not([disabled])').data('canton');
            var value = $(this).find(':selected:not([disabled])').text();

            if (value !== undefined && value.length > 0) {
                // Update Locations
                $('#location option[data-canton!="' + value + '"]:not(:disabled)').attr('disabled', 'disabled');

                // Update Places
                $('#place option[data-canton!="' + value + '"]:not(:disabled)').attr('disabled', 'disabled');

                // Reset select
                $('.search-form select:not(.browser-default)').formSelect();
            } else {
                // No value selected (like "Tous")
                $('#location option[value!=""]').attr('disabled', false);
                $('#place option[value!=""]').attr('disabled', false);
                $('.search-form select:not(.browser-default)').formSelect();
            }
        });

        // Locations (Ville)
        $('body').on('change', '#location', function () {
            var location = $(this).find(':selected:not([disabled])').val();
            var canton = $(this).find(':selected:not([disabled])').data('canton');

            if (location !== undefined && location.length > 0) {
                // Update Places
                $('#place option[data-city!="' + location + '"]:not(:disabled)').attr('disabled', 'disabled');

                // Reset select
                $('#place:not(.browser-default)').formSelect();
            } else {
                // No value selected (like "Tous")
                $('#place option[value!=""]').attr('disabled', false);
                $('#area option[value!=""]').attr('disabled', false);
                $('.search-form select:not(.browser-default)').formSelect();
            }

            if (canton !== undefined && canton.length > 0) {
                // Select the right area
                $('#area option[data-canton="' + canton + '"]').attr('selected', 'selected');

                // Reset select
                $('#area:not(.browser-default)').formSelect();
            } else {
                // No value selected (like "Tous")
                $('#area option').attr('disabled', false);
                $('#place option').attr('disabled', false);
                $('.search-form select:not(.browser-default)').formSelect();
            }
        });

        // Places (Lieu de représentation)
        $('body').on('change', '#place', function () {
            var location = $(this).find(':selected:not([disabled])').data('city');
            var canton = $(this).find(':selected:not([disabled])').data('canton');

            if (location !== undefined && location.length > 0) {
                // Select the right location
                $('#location option[value="' + location + '"]').attr('selected', 'selected');

                // Reset select
                $('#location:not(.browser-default)').formSelect();
            } else {
                // No value selected (like "Tous")
                $('#location option[value!=""]').attr('disabled', false);
                $('#area option[value!=""]').attr('disabled', false);
                $('.search-form select:not(.browser-default)').formSelect();
            }

            if (canton !== undefined && canton.length > 0) {
                // Select the right area
                $('#area option[data-canton="' + canton + '"]').attr('selected', 'selected');

                // Reset select
                $('#area:not(.browser-default)').formSelect();
            } else {
                // No value selected (like "Tous")
                $('#location option[value!=""]').attr('disabled', false);
                $('#area option[value!=""]').attr('disabled', false);
                $('.search-form select:not(.browser-default)').formSelect();
            }
        });
    },

    multipleSelectAllOption: function () {
        $('body').find('select[multiple]').on('change', '.search-form select[multiple]', function () {
            var selectToUpdate = $(this);

            var value = selectToUpdate.find(':selected').val();

            if (value !== undefined && value.length === 0) {

                selectToUpdate.formSelect();

                var textValue = selectToUpdate.find('option:first').html();
                selectToUpdate.parents('.input-field').find(':text').val(textValue);

                selectToUpdate.parents('.input-field').find('.select-dropdown > li.active').removeClass('active');
                selectToUpdate.parents('.input-field').find('.select-dropdown > li').find('[type=checkbox]:checked').prop('checked', false);

                selectToUpdate.find('option:first').attr('selected', 'selected');
            }
        });
    },

    infiniteScroll: function () {
        var self = this;

        var initialItemHeight = $('.event-listing .event:last').height();
        var initialItemsNb = $('.event-listing .event').length;
        var noMoreToLoad = false;

        var setInfinite = function () {
            if ($('.event-listing .event').length > 0) {
                var eventOffset = $('.event-listing .event:last').offset();
            } else {
                var eventOffset = 0;
            }


            // If the user reach the bottom of the events list
            if (eventOffset && ((eventOffset.top + initialItemHeight) - $(window).height() <= $(window).scrollTop()) && initialItemsNb >= 12 && !noMoreToLoad) {
                if (self.lockAjaxGetResults) {
                    // Pending AJAX request... wait
                    return;
                }

                self.lockAjaxGetResults = true;

                // Display the loading spinner
                $('#events .loading').fadeIn();

                var nbDisplayedItems = $('.event-listing .event').length;
                var startTime = new Date().getTime();

                self.ajaxGetResults(function (response) {
                    if (response.success) {
                        var fakeLoadingTime = 0;
                        var requestTime = new Date().getTime() - startTime;

                        if (requestTime < 1000) {
                            fakeLoadingTime = 1000 - requestTime;
                        }

                        var appendNewEvents = function(response) {
                            // Append the events to the existing list
                            $('.event-listing').append(response.data.events);

                            // Set hover events and hide the loading spinner
                            var events = $('.event-listing').find('.event');
                            self.updateDisplay(events);

                            if (bowser.firefox) {
                                // Bux fix for Firefox
                                $(window).trigger('resize');
                            }

                            var total = parseInt(response.data.nbTotalEvents);
                            var totalDisplayed = $('.event-listing .event').length;

                            if (totalDisplayed == total) {
                                noMoreToLoad = true;
                            }
                        };

                        if (fakeLoadingTime > 0) {
                            setTimeout(appendNewEvents(response), fakeLoadingTime);
                        } else {
                            appendNewEvents(response);
                        }
                    } else {
                        console.log('An error occured!');
                    }

                    self.lockAjaxGetResults = false;
                }, function (jqXHR, textStatus) {
                    self.lockAjaxGetResults = false;
                    console.log("Request failed: " + textStatus);
                }, nbDisplayedItems);
            }
        };

        $(window).on('scroll', setInfinite);
        $(window).on('resize', setInfinite);

        setInfinite();
    },

    reinitializeSearch: function() {
        var self = this;
        $('body').on('click', '.btn-reinit', function(e) {
            e.preventDefault();

            // Clear the search criteria
            $('.search-form #searchquery').val('');

            $('select', self.$searchForm).prop('selectedIndex', 0);
            $('select', self.$searchForm).formSelect();

            if (!bowser.mobile) {
                var $advanced = $('#advanced-events-search');

                $('option:selected', $advanced).prop('selected', false);
                $('select', $advanced).formSelect('destroy');
                $('select', $advanced).formSelect();
            }

            // Trigger the search button to update the results
            if (!bowser.mobile) {
                self.$searchForm.add('#advanced-actors-search').submit();
            } else {
                $('#search-box-mobile form').first().trigger('submit');
            }
        });
    },
};

module.exports = new FrontEventsArchive();
